"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawAll = exports.close = exports.open = exports.get = void 0;
require("../../../lib/mathUtils-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
require("./rogueStats-sidecar");
var help = [
    'Welcome to Rogue!',
    'Use the arrow keys to move.',
    'Press ? for help.',
    'Press i for inventory.',
    'Press m for messages.',
    'Press z to cast spells.',
    'Press Esc to exit menus.',
    'Press Enter to select items.',
];
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            isOpen: false,
        };
    }
    return _obj;
};
exports.get = get;
var open = function () {
    var obj = (0, exports.get)();
    obj.isOpen = true;
};
exports.open = open;
var close = function () {
    var obj = (0, exports.get)();
    obj.isOpen = false;
};
exports.close = close;
var drawAll = function () {
    var obj = (0, exports.get)();
    if (!obj.isOpen) {
        return;
    }
    var x = 1;
    var y = 1;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Help!');
    y++;
    for (var i = 0; i < help.length; i++) {
        var item = help[i];
        y++;
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, item);
    }
};
exports.drawAll = drawAll;
